import styled from "styled-components";
import Button from "../../designComponents/Button";

export const SettingsWrapper = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

export const Input = styled.input`
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  display: flex;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #1890ff;
  }
`;

export const SaveButton = styled.button`
  background-color: #1890ff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  &:hover {
    background-color: #40a9ff;
  }
`;

export const AddButton = styled(Button)`
  color: white;
  background-color: #0a56af;
`;
